import { Chip, Tooltip } from '@atgfr8/atg-ui-tailwind';
import { ContentCopyIcon } from '@atgfr8/icons';

type PropsT = {
  id: string | number;
};

const DUPLICATE_CARRIER_TOOLTIP_MESSAGE =
  'This is a duplicate carrier. A matching carrier profile with the same DOT and/or MC number already exists in the system as the approved and updated profile to use.';

export const DuplicateCarrierIndicator = (props: PropsT) => (
  <Tooltip
    title={DUPLICATE_CARRIER_TOOLTIP_MESSAGE}
    dataTestId={`duplicate-carrier-tooltip-${props.id}`}
  >
    <Chip
      id={`duplicate-carrier-chip-${props.id}`}
      variant="filled"
      backgroundColor="#F59D25"
      class="p-0! w-8! h-8! justify-center"
      style={{ color: '#0000008A' }}
      text={<ContentCopyIcon size={22} />}
    />
  </Tooltip>
);
